import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IJourney } from '../../../assets/types/dtoTypes';

@Injectable({ providedIn: 'root' })
export class JourneyService {
  private http = inject(HttpClient);

  private url = `${environment.apiUrl}/journey`;

  getMyJourney(): Observable<IJourney> {
    return this.http.get<IJourney>(`${this.url}/me`);
  }

  getJourneyById(id: string): Observable<IJourney> {
    return this.http.get<IJourney>(`${this.url}/${id}`);
  }
}
